__webpack_require__.p = "https://powerpoint-canary.ahaslides.com/";